import { TrackingEventKey } from "@next-platform/packages-ts-types";

import { CampaignswellEvent } from "@/features/tracking/providers/campaignswell/campaignswellEvents";

/**
 * Browser-side map from `TrackingEventKey` to the CampaignsWell GA4 events.
 *
 * ⚠️ BROWSER-ONLY — DO NOT REUSE SERVER-SIDE. `TrackingEventKey.Purchase`
 * means two different things depending on where it's produced:
 *
 * - Server-side it means *renewal* (`capiProducer.ts` maps
 *   `PaymentType.RENEWAL → Purchase`). A rebill has no browser session so
 *   it can never reach this map — and calling it `cw_nrc_purchase` would
 *   tell CampaignsWell every renewal was a one-off sale.
 * - Browser-side it means *no `subscription_id` on the Sticky response*
 *   (see `buildCheckoutConversionInputs`), which is genuinely
 *   non-recurring. Our web checkout only sells subscriptions, so expected
 *   volume is near zero; the mapping exists so a real one-off product
 *   doesn't go untracked.
 *
 * Unmapped keys no-op: `Signup` / `PaywallViewed` / `CheckoutStarted` /
 * `TrialStart` aren't conversions CampaignsWell reconciles against Sticky,
 * and `SubscriptionRenewal` / `Refund` are server-side only.
 */
const campaignswellEventMap: Partial<Record<TrackingEventKey, CampaignswellEvent>> = {
  [TrackingEventKey.Subscribe]: CampaignswellEvent.SUBSCRIBE,
  [TrackingEventKey.Purchase]: CampaignswellEvent.NRC_PURCHASE,
};

export default function resolveCampaignswellEventName(eventKey: TrackingEventKey): CampaignswellEvent | undefined {
  return campaignswellEventMap[eventKey];
}
